// removed by extract-text-webpack-plugin
module.exports = {"languageButtonContainer":"style__languageButtonContainer___30CTf","languageButtonContainerOverlay":"style__languageButtonContainerOverlay___13mp4","languageButton":"style__languageButton___1oEU0","languageButtonVIP":"style__languageButtonVIP___3wFPZ","languageButtonDropdown":"style__languageButtonDropdown___2MuHN","languageButtonDropdownItem":"style__languageButtonDropdownItem___3oPup","languageButtonTriangle":"style__languageButtonTriangle___1rq5Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/language-button/style.css
// module id = 255
// module chunks = 0